import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/enterpris/EnterprisList.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/Member',
    name: 'Member',
    component: () => import('../views/yuangong/member.vue')
  },
  /*
  {
    path: '/Member',
    name: 'Member',
    component: () => import('../views/member/MemberView.vue')
  },
  */
  {
    path: '/EnterprisList',
    name: 'EnterprisList',
    component: () => import('../views/enterpris/EnterprisList.vue')
  },
  {
    path: '/SendSmsRand',
    name: 'SendSmsRand',
    component: () => import('../views/enterpris/SendSmsRand.vue')
  },

  {
    path: '/YuYue',
    name: 'YuYue',
    component: () => import('../views/enterpris/YuYue.vue')
  },

  {
    path: '/EnterpriListPublic',
    name: 'EnterpriListPublic',
    component: () => import('../views/enterpris/EnterpriListPublic.vue')
  },
  {
    path: '/EnterprisListAll',
    name: 'EnterprisListAll',
    component: () => import('../views/enterpris/EnterprisListAll.vue')
  },
  {
    path: '/MarkManige',
    name: 'MarkManige',
    component: () => import('../views/enterpris/MarkManige.vue')
  },
  {
    path: '/YujinLeida',
    name: 'YujinLeida',
    component: () => import('../views/enterpris/YujinLeida.vue')
  },
  
  {
    path: '/Credentiallist',
    name: 'Credentiallist',
    component: () => import('../views/credential/Credential.vue')
  },

  {
    path: '/CredentialPublic',
    name: 'CredentialPublic',
    component: () => import('../views/credential/CredentialPublic.vue')
  },
  {
    path: '/YuYueCert',
    name: 'YuYueCert',
    component: () => import('../views/credential/YuYue.vue')
  },
  {
    path: '/CredentialPublic1',
    name: 'CredentialPublic1',
    component: () => import('../views/credential/CredentialPublic1.vue')
  },
  {
    path: '/YuanGong',
    name: 'YuanGong',
    component: () => import('../views/yuangong/YuanGongView.vue')
  },
  {
    path: '/ShowRole',
    name: 'ShowRole',
    component: () => import('../views/yuangong/ShowRole.vue')
  },
  {
    path: '/DepartL',
    name: 'DepartL',
    component: () => import('../views/yuangong/DepartL.vue')
  },
  {
    path: '/EnterCertList',
    name: 'EnterCertList',
    component: () => import('../views/cert/EnterCertList.vue')
  },
  {
    path: '/EnterHeTongList',
    name: 'EnterHeTongList',
    component: () => import('../views/hetong/EnterHeTongList.vue')
  },
  {
    path: '/CertHeTongList',
    name: 'CertHeTongList',
    component: () => import('../views/hetong/CertHeTongList.vue')
  },
  {
    path: '/EnterImport',
    name: 'EnterImport',
    component: () => import('../views/system/EnterImport.vue')
  },

  {
    path: '/SmsSet',
    name: 'SmsSet',
    component: () => import('../views/system/SmsSet.vue')
  },
  {
    path: '/HtShengHe',
    name: 'HtShengHe',
    component: () => import('../views/hetong/HtShengHe.vue')
  },
  {
    path: '/RevShengHe',
    name: 'RevShengHe',
    component: () => import('../views/hetong/RevShengHe.vue')
  },
  {
    path: '/TotalV',
    name: 'TotalV',
    component: () => import('../views/hetong/TotalV.vue')
  },
  {
    path: '/link/MakeLink',
    name: 'Makelink',
    component: () => import('../views/link/MakeLink.vue')
  },
  {
    path: '/link/HuoKeAasst',
    name: 'HuoKeAasst',
    component: () => import('../views/link/HuoKeAasst.vue')
  },
  {
    path: '/link/WxQuan',
    name: 'WxQuan',
    component: () => import('../views/link/WxQuan.vue')
  },
  {
    path: '/link/WxPengYou',
    name: 'WxPengYou',
    component: () => import('../views/link/WxPengYou.vue')
  },
  {
    path: '/link/leidalink',
    name: 'LeiDaLink',
    component: () => import('../views/link/LeiDaLink.vue')
  },
  {
    path: '/link/FenXi',
    name: 'FenXi',
    component: () => import('../views/link/FenXi.vue')
  },
  {
    path: '/aimarketauto/AiMsg',
    name: 'AiMsg',
    component: () => import('../views/aimarketauto/AiMsg.vue')
  },
  {
    path: '/aimarketauto/AiGroup',
    name: 'AiGroup',
    component: () => import('../views/aimarketauto/AiGroup.vue')
  },
  {
    path: '/aimarketauto/AiFrdguoup',
    name: 'AiFrdguoup',
    component: () => import('../views/aimarketauto/AiFrdguoup.vue')
  },
  {
    path: '/aimarketauto/AiAuto',
    name: 'AiAuto',
    component: () => import('../views/aimarketauto/AiAuto.vue')
  },
  {
    path: '/kanban/MainKanban',
    name: 'MainKanban',
    component: () => import('../views/kanban/MainKanban.vue')
  },
  {
    path: '/kanban/SopTask',
    name: 'SopTask',
    component: () => import('../views/kanban/SopTask.vue')
  },
  {
    path: '/kanban/EnterRecord',
    name: 'EnterRecord',
    component: () => import('../views/kanban/EnterRecord.vue')
  },
  {
    path: '/system/FjUpLoad',
    name: 'FjUpLoad',
    component: () => import('../views/system/FjUpLoad.vue')
  },
  {
    path: '/system/BandUser',
    name: 'BandUser',
    component: () => import('../views/system/BandUser.vue')
  },
  {
    path: '/system/banduserdo',
    name: 'BandUserDo',
    component: () => import('../views/system/BandUserDo.vue')
  },  
  {
    path: '/system/exevent',
    name: 'ExEvent',
    component: () => import('../views/system/ExEvent.vue')
  },  
  {
    path: '/system/inevent',
    name: 'InEvent',
    component: () => import('../views/system/InEvent.vue')
  },  
  {
    path: '/system/needask',
    name: 'NeedAsk',
    component: () => import('../views/system/NeedAsk.vue')
  },
  {
    path: '/font/needask',
    name: 'FontNeedAsk',
    component: () => import('../views/font/FontNeedAsk.vue')
  },
  {
    // ★ 紫灵AI 插件绑定的「桥接页」。
    //
    // 为什么需要它：插件页面与 SCRM **不同源**，浏览器不允许它读 SCRM 的登录态；
    // 所以"判断有没有登录、并把登录态换成一次性码"必须由一个**跑在 SCRM 自己域内**
    // 的页面来做。它是弹窗内容（不套 FaceFrame），所以放顶层路由。
    //
    // 方案与安全责任划分见 docs/06-插件登录方案（弹窗SSO）.md。
    path: '/sso/plugin',
    name: 'PluginSSO',
    component: () => import('../views/sso/PluginSSO.vue')
  },
  {
    path: '/zhishiku/ZhiShiKu',
    name: 'ZhiShiKu',
    component: () => import('../views/zhishiku/ZhiShiKu.vue')
  },
  {
    path: '/h5/GeJinKf',
    name: 'GeJinKf',
    component: () => import('../views/h5/GeJinKf.vue')
  },
  {
    path: '/h5/BasesInfo',
    name: 'BasesInfo',
    component: () => import('../views/h5/BasesInfo.vue')
  },
  {
    path: '/h5/EyeCheck',
    name: 'EyeCheck',
    component: () => import('../views/h5/EyeCheck.vue')
  },

  // ★ 2026-10-01：**老地址兼容**（企微侧边栏 / 收藏夹 / 老二维码里很可能还配着没有 `/h5` 前缀的地址）。
  //   为什么要加：真实路由是 `/h5/GeJinKf` 这些，而路由表**没有兜底路由** ⇒
  //   打开老地址会渲染**空白页**；更麻烦的是 request.js 里"企微内 H5 不跳登录页"的判定
  //   也认不出它们 ⇒ 一旦 401 就会被当成后台页面送去 /login（登完又被送回首页）。
  //   这里统一用**函数式 redirect 并把 query 带上**（`?comid=` 不能丢，那正是 H5 的身份来源）。
  { path: '/GeJinKf', redirect: (to) => ({ path: '/h5/GeJinKf', query: to.query }) },
  { path: '/BasesInfo', redirect: (to) => ({ path: '/h5/BasesInfo', query: to.query }) },
  { path: '/EyeCheck', redirect: (to) => ({ path: '/h5/EyeCheck', query: to.query }) },
  { path: '/LeiDaLink', redirect: (to) => ({ path: '/link/leidalink', query: to.query }) },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
